module.exports = __webpack_public_path__ + "static/img/logo_diario.f66250c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/DOE-AL/logo_diario.png
// module id = +Z2+
// module chunks = 1